import React, { useState } from "react";
import { Alert } from "components/Alert";
import { SupportLink } from "components/SupportLink";
import { motion } from "framer-motion";
import { useExoticMessageDismissed } from "../useExoticMessageDismissed";

import * as styles from "./ExoticMessage.module.scss";

export const ExoticMessage = () => {
  const { dismissed, setDismissed } = useExoticMessageDismissed();
  const [isAnimating, setIsAnimating] = useState(false);

  const handleDismiss = () => {
    setIsAnimating(true);
  };

  const handleAnimationComplete = () => {
    setDismissed(true);
    setIsAnimating(false);
  };

  return (
    <motion.div
      initial={false}
      animate={{
        opacity: isAnimating ? 0 : 1,
        y: isAnimating ? "-2rem" : 0,
      }}
      transition={{ duration: 0.3 }}
      onAnimationComplete={handleAnimationComplete}
      style={{ order: dismissed ? "initial" : -1 }}
    >
      <Alert
        className={dismissed ? styles.bottomMessage : styles.topMessage}
        variant="info"
        size="small"
        onDismiss={dismissed ? undefined : handleDismiss}
      >
        <span>
          Exotics are calculated using the{" "}
          <SupportLink options={{ articleId: "12279084203663" }} hideChevron>
            Pickle Pool
          </SupportLink>
        </span>
      </Alert>
    </motion.div>
  );
};
